import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuIdService {
  private imagePaths: { [domain: string]: { [id: number]: string } } = {
    'uaedemo-primez.insure.digital': {
      6130: '/assets/images/menuLogo/primez-logo.png'
    },
    'sudlife-primez.insure.digital': {
      6130: '/assets/images/menuLogo/primez-logo.png'
    },
    'cholams-primez.insure.digital': {
      6130: '/assets/images/menuLogo/primez-logo.png'
    },
    'zuno-primez.insure.digital': {
      6130: '/assets/images/menuLogo/primez-logo.png'
    },
    'starhealth-primez.insure.digital': {
      6130: '/assets/images/menuLogo/primez-logo.png'
    },
    'uat-core-primez.insure.digital.com': {
      6130: '/assets/images/menuLogo/kenindia-logo.png'
    },
    'localhost': {
      6130: '/assets/images/menuLogo/kenindia-logo.png',
    },
    'malawi.com': {
      6050: '/assets/images/menuLogo/IAM.png',
    }
  };


  date: any = new Date().getFullYear()
  private footerContent: { [domain: string]: string } = {
    'uat-core-primez.insure.digital.com': `Afrisure @ 2023 ${'- ' + this.date} Core Insurance Version: 0.0.1 - Development`,
    'uaedemo-primez.insure.digital': `PrimeZ @ 2023 ${'- ' + this.date} Core Insurance Version: 0.0.1 - Development`,
    'sudlife-primez.insure.digital': `PrimeZ @ 2023 ${'- ' + this.date} Core Insurance Version: 0.0.1 - Development`,
    'cholams-primez.insure.digital': `PrimeZ @ 2023 ${'- ' + this.date} Core Insurance Version: 0.0.1 - Development`,
    'zuno-primez.insure.digital': `PrimeZ @ 2023 ${'- ' + this.date} Core Insurance Version: 0.0.1 - Development`,
    'starhealth-primez.insure.digital': `PrimeZ @ 2023 ${'- ' + this.date} Core Insurance Version: 0.0.1 - Development`,
    'localhost': `Afrisure @ 2023 ${'- ' + this.date} Core Insurance Version: 0.0.1 - Development`,
  };

  // private colors: { [id: number]: string } = {
  //   1: '#2e3192',  // color for ID 1
  //   2: '#cfc04d',  // color for ID 2
  //   3: '#376092',  // color for ID 3
  //   // Add more color mappings for other IDs as needed
  // };

  // private tablebg: { [id: number]: { bgColor: string; textColor: string } } = {
  //   1: { bgColor: '#f2f2f2', textColor: '#000000' },  // For ID 1, white background and black text color
  //   2: { bgColor: '#000000', textColor: '#ffffff' },  // For ID 2, black background and white text color
  //   3: { bgColor: '#000000', textColor: '#ffffff' },  // For ID 2, black background and white text color

  //   // Add more color mappings for other IDs as needed
  // };

  // private mkIDSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // private akIIDSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // private IAZIDSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private activeImageURLSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private activefooterURLSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  orgAppID!: number;
  domain!: string;
  // private activeColorSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  // private activetableSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor() {
    // No HTTP request logic here

  }
  getid(id: number) {
    // const mkIDValue = id === 1;
    // this.mkIDSubject.next(mkIDValue);
    // const akIIDValue = id === 2;
    // this.akIIDSubject.next(akIIDValue);
    // const IAZIDValue = id === 3
    // this.IAZIDSubject.next(IAZIDValue);
    // if (!mkIDValue && !akIIDValue && !IAZIDValue) {
    //   this.mkIDSubject.next(true);

    // }

    // this.getImagePath(id); // Get image path for ID 1
    // this.getColorById(id); // Get color for ID 1
  }
  getOrgAppId() {
    return this.orgAppID
  }
  getImagePath(id: number, domain: string): void {
    this.orgAppID = id;
    const domainImagePaths = this.imagePaths[domain];
    if (domainImagePaths) {
      const imageURL = domainImagePaths[id];
      if (imageURL) {
        this.activeImageURLSubject.next(imageURL);
      } else {
        // Handle case where image path is not found for the given ID and domain
      }
    } else {
      // Handle case where domain is not found in imagePaths
    }
  }

  getFooterContent(domain: string): void {
    this.domain = domain;
    const imageURL = this.footerContent[domain];
    if (imageURL) {
      this.activefooterURLSubject.next(imageURL);
    } else {

    }
  }
  phoneCode() {
    let domain = window.location.hostname;
    if (domain == "sudlife-primez.insure.digital" || domain == "cholams-primez.insure.digital" || domain == "zuno-primez.insure.digital" || domain == "starhealth-primez.insure.digital") {
      return "IND"
    }
    else if (domain == "uaedemo-primez.insure.digital") {
      return "UAE";
    }
    else {
      return "KEN"
    }
  }
  quotationImg() {
    let domain = window.location.hostname;
    if (domain == "sudlife-primez.insure.digital") {
      return 'SUD_Life.png'
    }
    else if (domain == "cholams-primez.insure.digital") {
      return 'Chola.png'
    }
    else if (domain == "zuno-primez.insure.digital") {
      return 'Zuno.jpg'
    }
    else if (domain == "starhealth-primez.insure.digital") {
      return 'StarHealth.jpg'
    }
    else {
      return 'healthInsurance.png'
    }
  }
  homeImg() {
    let domain = window.location.hostname;
    if (domain == "sudlife-primez.insure.digital" || domain == "sudlife-primez.insure.digital" || domain == "cholams-primez.insure.digital" || domain == "zuno-primez.insure.digital" || domain == "starhealth-primez.insure.digital" || domain == "uaedemo-primez.insure.digital") {
      return 'Primez.png'
    }
    else {
      return 'AfriSure.png'
    }
  }
  // Modify the getColorById method to accept the ID as a parameter
  // getColorById(id: number): void {
  //   const color = this.colors[id];
  //   if (color) {
  //     this.activeColorSubject.next(color);
  //   } else {
  //     this.activeColorSubject.next('#2e3192'); // Default color if the ID doesn't match
  //   }
  //   var table = this.tablebg[id];
  //   if (table) {
  //     this.activetableSubject.next(JSON.stringify(table));
  //   } else {
  //     this.activeColorSubject.next('');
  //   }
  // }

  // getMkID(): Observable<boolean> {
  //   return this.mkIDSubject.asObservable();
  // }

  // getAkID(): Observable<boolean> {
  //   return this.akIIDSubject.asObservable();
  // }

  // getIAZID(): Observable<boolean> {
  //   return this.IAZIDSubject.asObservable();
  // }

  getActiveImageURL(): Observable<string> {
    return this.activeImageURLSubject.asObservable();
  }

  activFooterContent(): Observable<string> {
    return this.activefooterURLSubject.asObservable();
  }
  // getActiveColor(): Observable<string> {
  //   return this.activeColorSubject.asObservable();
  // }

  // getTablecolor(): Observable<string> {
  //   return this.activetableSubject.asObservable();
  // }
}
